<template>
    <div class="manuscript">
        <div class="head">
            {{this.manuContent.headTitle}}
        </div>
        <div class="content">
            <div class="content-scorll">
                <div class="title">{{this.manuContent.title}}</div>
                <div class="tag">
                    <div :style="{'text-align':(manuContent.resource?'left':'center')}">
                        <div class="tag-right">
                            <div v-if="manuContent.resource" class="resource">
                                <span v-for="(item1,index1) in manuContent.resource" :class="item1"></span>
                            </div>
                            <span class="tag-name">{{manuContent.XQNEWSSOURCES}}</span>
                            <span class="line" v-if="manuContent.XQNEWSSOURCES">|</span>
                            <span>{{manuContent.time || manuContent.shareTime}}</span>
                        </div>
                    </div>
                </div>
                <div class="img-vidio">
                    <div class="img-list" v-if="manuContent.XQ_PicUrl ">
                        <div v-if="imgBtnOne || imgBtnHave"  class="img-btn-origin origin-left" @click="last(clickKey,manuContent.headTitleTag)"><img src="../../../assets/images/springFrame/img-origin.png" ></div>
                        <div v-if="imgBtnBoth || imgBtnNo" class="img-btn-origin tran-left" @click="last(clickKey,manuContent.headTitleTag)"><img src="../../../assets/images/springFrame/img-next.png" ></div>
                        <div class="img-vidio-div">
                            <img v-if="showLoadTag == true" style="position: absolute;width: 4%;height: 5%;margin-top: 320px;" src="../../../assets/images/springFrame/loading.gif"/>
                            <!--<div class="img-vidio-img" v-if="showLoadTag == true"><img style="margin-top: 350px;" src="../../../assets/images/springFrame/loading.gif"/></div>-->
                            <div class="img-vidio-img"><img v-if="manuContent.XQ_PicUrl[0].picUrl || imgs_picUrl" :src="imgs_picUrl || manuContent.XQ_PicUrl[0].picUrl" ></div>
                        </div>
                        <div v-if="imgBtnOne || imgBtnNo" class="img-btn-next tran-right" @click="next(clickKey,manuContent.headTitleTag)"><img src="../../../assets/images/springFrame/img-origin.png" ></div>
                        <div v-if="imgBtnBoth || imgBtnHave" class="img-btn-next origin-right" @click="next(clickKey,manuContent.headTitleTag)"><img src="../../../assets/images/springFrame/img-next.png" ></div>
                    </div>
                    <div class="img-list" v-if="manuContent.XQ_ImgUrl ">
                        <div v-if="imgBtnOne || imgBtnHave"  class="img-btn-origin origin-left" @click="last(clickKey,manuContent.headTitleTag)"><img src="../../../assets/images/springFrame/img-origin.png" ></div>
                        <div v-if="imgBtnBoth || imgBtnNo" class="img-btn-origin tran-left" @click="last(clickKey,manuContent.headTitleTag)"><img src="../../../assets/images/springFrame/img-next.png" ></div>
                        <div class="img-vidio-div">
                            <img v-if="showLoadTag == true" style="position: absolute;width: 4%;height: 5%;margin-top: 320px;" src="../../../assets/images/springFrame/loading.gif"/>
                            <div>
                                <div class="img-vidio-img"><img v-if="manuContent.XQ_ImgUrl[0].Url || imgs_Url" :src="imgs_Url || manuContent.XQ_ImgUrl[0].Url" ></div>
                                <div class="img-titleTag">
                                    <div :title="imgs_Title || manuContent.XQ_ImgUrl[0].Title" class="img-titleTag-con" v-if="manuContent.XQ_ImgUrl[0].Title || imgs_Title" v-html="imgs_Title || manuContent.XQ_ImgUrl[0].Title"></div>
                                </div>
                            </div>
                        </div>
                        <div v-if="imgBtnOne || imgBtnNo" class="img-btn-next tran-right" @click="next(clickKey,manuContent.headTitleTag)"><img src="../../../assets/images/springFrame/img-origin.png" ></div>
                        <div v-if="imgBtnBoth || imgBtnHave" class="img-btn-next origin-right" @click="next(clickKey,manuContent.headTitleTag)"><img src="../../../assets/images/springFrame/img-next.png" ></div>
                    </div>
                    
                    <div class="img-vidio-info" v-if="manuContent.XQ_VideoUrl">
                        <div class="img-vidio-video">
                            <video 
                                width=95% height=95%
                                :src="manuContent.XQ_VideoUrl" 
                                controls
                                ref="videoRef"
                                @play="videoIsPlay = true;"
                                @pause="videoIsPlay = false;"
                                @ended="videoIsPlay = false;"
                            ></video>
                        </div>
                        <div v-show="!videoIsPlay" class="video-icon-detail" @click="changeVideoStatus()"><img class="video-play" src="../../../assets/images/springFrame/video.png" alt="" /></div>
                    </div>
                    
                </div>
                <div v-if="manuContent.XQCONTENT && manuContent.typeTag != 3" class="words" v-html="manuContent.XQCONTENT.replace(/rgb\(0, 0, 0\)/g,'rgb(255, 255, 255)').replace(/font-size: 16/g,'font-size: 38').replace(/font-size: 19/g,'font-size: 38').replace(/font-size: 14/g,'font-size: 28').replace(/\r\n/g,'<br/>').replace(/\s/g, ' ')"></div>
            
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "manuscriptContent",
        props: {
            showManuObj: {
                type: Object,
                default: {}
            },
        },
        data(){
            return {
                manuContent: this.showManuObj,
                imgs_Url: '',
                imgs_Title: '',
                imgs_picUrl: '',
                clickKey: 0,
                imgBtnNo: this.showManuObj.imgBtnNo,
                imgBtnHave: this.showManuObj.imgBtnHave,
                imgBtnOne: this.showManuObj.imgBtnOne,
                imgBtnBoth: false,

                videoIsPlay: false,

                imgCountArr: 0,
                showTag: false,
                showLoadTag: true,
            }
        },
        
        mounted(){
            this.loading();
        },
        methods: { 
            loading(){
                this.showLoadTag = true;
                this.showTag = false;
                this.imgCountArr = 0;
                if(this.showManuObj.XQ_PicUrl){
                    var imgArr = this.showManuObj.XQ_PicUrl;
                    var imgCount = this.imgCountArr;
                    for(let img of imgArr) {
                        let image = new Image();
                        image.src = img.picUrl; 
                        image.onload = () =>{
                            imgCount++;
                            //图片加载百分比
                            // this.imgCountArr = parseInt((imgCount / imgArr.length) * 100);
                            if(imgCount == imgArr.length){
                                //加载完成后执行
                                this.showLoadTag = false;
                                this.showTag = true;
                            }
                        }
                    }
                } else {
                    if(this.showManuObj.XQ_ImgUrl){
                        var imgArr = this.showManuObj.XQ_ImgUrl;
                        var imgCount = this.imgCountArr;
                        for(let img of imgArr) {
                            let image = new Image();
                            image.src = img.Url;
                            image.onload = () =>{
                                imgCount++;
                                //图片加载百分比
                                // this.imgCountArr = parseInt((imgCount / imgArr.length) * 100);
                                if(imgCount == imgArr.length){
                                    //加载完成后执行
                                    this.showLoadTag = false;
                                    this.showTag = true;
                                    
                                }
                            }
                        }
                    }
                }
                
            },
            changeVideoStatus(){
                const video = this.$refs.videoRef;
                if(video.paused){
                    video.play();
                } else {
                    video.pause();
                }
            },
            last(key,tag){
                if(this.imgBtnOne == false && this.showTag == true){
                    this.imgBtnBoth = false;
                    if(key>0 && tag == 'zxgxgj'){
                        this.imgs_picUrl = this.manuContent.XQ_PicUrl[key-1].picUrl;
                        this.clickKey = key-1;
                    }
                    if(key>0 && tag == 'zxfb'){
                        this.imgs_Url = this.manuContent.XQ_ImgUrl[key-1].Url;
                        this.imgs_Title = this.manuContent.XQ_ImgUrl[key-1].Title;
                        this.clickKey = key-1;
                    }

                    if(this.clickKey == 0){
                        this.imgBtnNo = false;
                        this.imgBtnHave = true;
                    } else {
                        this.imgBtnNo = true;
                        this.imgBtnHave = false;
                    }
                    
                    if(this.manuContent.XQ_PicUrl){
                        if(this.clickKey>0 && this.clickKey<this.manuContent.XQ_PicUrl.length-1){
                            this.imgBtnBoth = true;
                            this.imgBtnNo = false;
                            this.imgBtnHave = false;
                        } 
                        
                    }
                    if(this.manuContent.XQ_ImgUrl){
                        if(this.clickKey>0 && this.clickKey<this.manuContent.XQ_ImgUrl.length-1){
                            this.imgBtnBoth = true;
                            this.imgBtnNo = false;
                            this.imgBtnHave = false;
                        } 
                    }
                }
                
            },
            next(key,tag){
                 
                if(this.showTag == true){
                    this.showLoadTag = false;
                    if(this.imgBtnOne == false){
                        this.imgBtnBoth = false;
                        if(this.manuContent.XQ_PicUrl){
                            if(key<this.manuContent.XQ_PicUrl.length-1 && tag == 'zxgxgj'){
                                this.imgs_picUrl = this.manuContent.XQ_PicUrl[key+1].picUrl;
                                this.clickKey = key+1;
                            }
                        }
                        if(this.manuContent.XQ_ImgUrl){
                            if(key<this.manuContent.XQ_ImgUrl.length-1 && tag == 'zxfb'){
                                this.imgs_Url = this.manuContent.XQ_ImgUrl[key+1].Url;
                                this.imgs_Title = this.manuContent.XQ_ImgUrl[key+1].Title;
                                this.clickKey = key+1;
                            }
                        }

                        if(this.manuContent.XQ_PicUrl){
                            if(this.clickKey == this.manuContent.XQ_PicUrl.length-1){
                                this.imgBtnNo = true;
                                this.imgBtnHave = false;
                            } 
                            if(this.clickKey<this.manuContent.XQ_PicUrl.length-1){
                                this.imgBtnBoth = true;
                                this.imgBtnNo = false;
                                this.imgBtnHave = false;
                            } 
                            
                        }
                        if(this.manuContent.XQ_ImgUrl){
                            if(this.clickKey == this.manuContent.XQ_ImgUrl.length-1){
                                this.imgBtnNo = true;
                                this.imgBtnHave = false;
                            }
                            if(this.clickKey<this.manuContent.XQ_ImgUrl.length-1){
                                this.imgBtnBoth = true;
                                this.imgBtnNo = false;
                                this.imgBtnHave = false;
                            } 
                        }

                    }
                } else {
                   this.showLoadTag = true;
                }
                
                
            },
        }
    }
</script>

<style>
    .manuscript {
        width: 2000px;
        height: 1300px;
        
    }
    .manuscript .head {
        font-size: 42px;
        text-align: center;
        margin-top: 45px;
        /*font-weight:bold;*/
        margin-left: 125px;
        font-family: hyk1gj;
    }
    .manuscript .content {
        
        margin-top: 70px;
    }
    .manuscript .content .content-scorll {
        position: absolute;
        height: 1050px;
        width: 86%;
        overflow: auto; 
        margin: 0 auto;
       
        left: 0;
        right: 0;
        
    }
    
    .manuscript .content .content-scorll .title {
        text-align: center;
        font-weight:bold;
        font-size: 50px;
        color: rgb(234,203,0);
        margin: 0px 60px 0px;
        
    }
    .manuscript .content .tag {
        font-size: 32px;
        margin-top: 20px;
    }
    .manuscript .content .tag .tag-center {
        text-align: center;
    }
    .manuscript .content .tag .tag-right {
        margin: auto;
    }
    .manuscript .content .tag .tag-right .tag-name {
        margin-left: 20px;
    }
    .manuscript .content .tag .tag-right .line {
        margin: 20px;
    }

    .manuscript .content .img-vidio {
        text-align: center;
        
    }
    .manuscript .content .img-vidio .img-list {
        float:left;
    }
    .manuscript .content .img-vidio .img-btn-origin {
        float:left;
        margin-left: 50px;
        
        height: 850px;
        cursor: pointer;
    }
    .manuscript .content .img-vidio .origin-left {
        line-height: 850px;
    }
    .manuscript .content .img-vidio .tran-left {
        transform: rotate(180deg);
        line-height: 970px;
    }
    .manuscript .content .img-vidio .img-btn-origin img {
        cursor: pointer;
    }
    .manuscript .content .img-vidio .img-btn-next {
        float:right;
        margin-right: 0px;
        height: 850px;
    }
    .manuscript .content .img-vidio .origin-right {
        line-height: 850px;
    }
    .manuscript .content .img-vidio .tran-right {
        transform: rotate(180deg);
        line-height: 970px;
    }
    .manuscript .content .img-vidio .img-btn-next img {
        cursor: pointer;
    }
    .manuscript .content .img-vidio .img-vidio-div {
        float:left;
        margin: 30px 30px 30px; 
        text-align: center;
    }
    .manuscript .content .img-vidio .img-vidio-img {
        width: 1450px;
        height: 750px;
        background: #000;
        text-align: center;
    }
    .manuscript .content .img-vidio .img-vidio-img img {
        max-width: 100%;
        max-height: 100%;
    }
    .manuscript .content .img-vidio .img-titleTag {
        height:50px;
    }
    
    .manuscript .content .img-vidio .img-titleTag-con {
        font-size: 28px;
        margin-top: 10px;
        width: 1450px;
        margin-bottom: 10px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .manuscript .content .img-vidio .img-vidio-info {
        margin: 30px 60px 30px;
        width: 1560px;
        height: 900px;
        background: #000;
        float:left;
        position: relative;
    }
    .manuscript .content .img-vidio .img-vidio-info .img-vidio-video {
        width: 1560px;
        height: 900px;
    }
    .manuscript .content .img-vidio .img-vidio-info .video-icon-detail {
        position:absolute;
        width: 120px;
        height: 120px;

        margin:auto;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }
    .manuscript .content .img-vidio .img-vidio-info .video-play {
        width: 120px;
        cursor: pointer;
    }

    .manuscript .content .words {
        font-size: 38px;
        margin: 30px 60px 30px;
        float:left;
        font-family: 宋体, SimSun;
        width: 1560px;
        color: #ffffff;
    }
    .manuscript .content .words img{
        display: block;
        margin: 0 auto;
    }

    .manuscript .content .tag .resource{
        display: flex;
        float:left;
        margin-top: 6px;
        margin-left: 580px;
        
    }
    .manuscript .content .tag .resource .weChat{
        background: url("../../../assets/images/icon-wechat.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    .manuscript .content .tag .resource .newspaper{
        background: url("../../../assets/images/icon-paper.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    .manuscript .content .tag .resource .website{
        background: url("../../../assets/images/icon-website.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    .manuscript .content .tag .resource .weibo{
        background: url("../../../assets/images/icon-weibo.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    .manuscript .content .tag .resource .douyin{
        background: url("../../../assets/images/icon-douyin.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    .manuscript .content .tag .resource .client{
        background: url("../../../assets/images/icon-client.png") center center no-repeat;
        background-size: 100% 100%;
        width: 26px;
        height: 32px;
    }
</style>
